function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 94"
}, props), React.createElement("path", {
  d: "M77.58 45.533s-8.323 9.557-27.266 9.557c-18.943 0-27.267-9.557-27.267-9.557",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M79.166 51.254s-8.805 10.118-28.852 10.118c-20.048 0-28.853-10.118-28.853-10.118M50.315 76.365v15.627",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M22.819 45.439c-1.395 4.673-2.172 9.571-2.19 14.55-.032 8.669 1.511 20.096 7.57 32.004M26.65 2c2.487 4.775 3.332 10.809 3.197 16.537M73.977 2c-3.282 6.296-3.708 14.783-2.783 21.88.691 5.32 2.252 10.51 4.326 15.292 2.801 6.463 4.449 13.56 4.48 20.824.03 8.669-1.512 20.096-7.572 32.004M29.86 18.537s5.732 5.627 20.454 5.627M70.77 18.537s-5.733 5.627-20.455 5.627",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M4.129 10.793h12.865c1.178 0 2.135 1.128 2.135 2.518v22.418H2V13.311c0-1.39.956-2.518 2.135-2.518h-.006z",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M41.552 42.025c-1.61 1.9-4.214 1.9-5.825 0-1.61-1.9-1.61-4.971 0-6.871 1.61-1.9 4.215-1.9 5.825 0 1.61 1.9 1.61 4.971 0 6.87zM44.205 32.024c3.073 3.625 3.073 9.506 0 13.131",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M34.333 38.59h-3.048c-2.85 0-5.226-2.592-5.442-5.947l-.222-3.436c-.216-3.355-2.586-5.946-5.442-5.946h-1.062",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M15.84 15.356H5.276v6.791H15.84v-6.79z",
  fill: "#C0D2D6"
}), React.createElement("path", {
  d: "M5.56 26.238h1.845M9.639 26.238h1.845M13.718 26.238h1.845M5.56 30.197h1.845M9.639 30.197h1.845M13.718 30.197h1.845",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10"
})));